import { getFromList } from '@soundxyz/utils';
import { useAuth } from '@context/auth/base';
import { ChannelStatsDocument, gql, useQuery } from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query ChannelStats($input: QueryChannelStatsInput!) {
    channelStats(input: $input) {
      channelId
      joinStatus
      memberCount
      postCount
      notificationStatus
    }
  }
`);

export function useChannelStats({ channelId }: { channelId: string }) {
  const { authUser } = useAuth();

  const { data, isLoading } = useQuery(ChannelStatsDocument, {
    variables: {
      input: {
        channelIds: [channelId],
      },
    },
    enabled: !!authUser,
    staleTime: 0,
  });

  const channelStats = getFromList(
    data?.data.channelStats,
    channelStat => channelStat.channelId === channelId && channelStat,
  );

  const memberCount = channelStats?.memberCount ?? 0;
  const postCount = channelStats?.postCount ?? 0;
  const joinStatus = channelStats?.joinStatus;
  const notificationStatus = channelStats?.notificationStatus;

  return { channelStats, memberCount, postCount, joinStatus, notificationStatus, isLoading };
}
